import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const ProductCountLabel = ({ productsCount }) =>
  productsCount > 0 ? (
    <p>
      <strong>{productsCount}</strong> produto(s) encontrado(s)
    </p>
  ) : null

const searchTitleConstructor = (isSearch, title) => {
  if (isSearch) {
    return `Resultados para "${title}"`
  } else if (title === '' || title === false) {
    return 'Produtos dos principais e-commerces.'
  } else {
    return title
  }
}

const SearchTitle = ({
  isSearch,
  isLoading,
  title,
  quantityFoundProducts,
  className
}) => {
  const searchTitle = searchTitleConstructor(isSearch, title)

  return (
    <div className={`container-results col-12 pb-2 py-md-2 ${className}`}>
      <div className={`row w-100`}>
        <div className='col-12'>
          {!isLoading ? (
            <Fragment>
              <h2 className='txt-font-body color-title pb-half'>
                {searchTitle}
              </h2>
              <ProductCountLabel productsCount={quantityFoundProducts} />
            </Fragment>
          ) : (
            <Fragment>
              <div className='row mx-0 pb-half pt-1'>
                <div className='py-half col-3 bg-ui-2' />
              </div>
              <div className='row mx-0 pt-half pb-1'>
                <div className='py-half col-5 bg-ui-3' />
              </div>
            </Fragment>
          )}
        </div>
      </div>
    </div>
  )
}

// schemas
SearchTitle.propTypes = {
  isSearch: PropTypes.bool,
  isLoading: PropTypes.bool,
  title: PropTypes.string,
  quantityFoundProducts: PropTypes.number,
  className: PropTypes.string
}

ProductCountLabel.propTypes = {
  productsCount: PropTypes.number
}

searchTitleConstructor.propTypes = {
  isSearch: PropTypes.bool,
  title: PropTypes.string
}

export default SearchTitle



// WEBPACK FOOTER //
// ./src/Catalog/Search/SearchTitle.js